import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { FaUserGraduate, FaUserTie, FaCalendar } from "react-icons/fa";
import HeaderPage from "../components/HeaderPage";
import DiagramaFinanzas from "../components/Finanzas/DiagramaFinanzas";
import DashboardCalendar from "../components/Eventos/DashboardCalendar";
import { useFinanzas } from "../context/FinanzasContext";
import { useUsers } from "../context/UsersContext"; // Para obtener estudiantes y profesores
import { useAuth } from "../context/AuthContext";
import { useEventos } from "../context/EventosContext";
import { useNavigate } from "react-router-dom"; // Importar navegación

const Dashboard = () => {
  const { user } = useAuth(); // Usuario autenticado
  const { pagos } = useFinanzas();
  const { eventos } = useEventos();
  const { students, teachers, fetchStudents, fetchTeachers, fetchStudentsByDirector } = useUsers();
  const [currentYearPagos, setCurrentYearPagos] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);
  const [totalTeachers, setTotalTeachers] = useState(0);
  const [totalEvents, setTotalEvents] = useState(0);
  const navigate = useNavigate(); // Hook para redirigir

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const filteredPagos = pagos.filter(
      (pago) => new Date(pago.fecha).getFullYear() === currentYear
    );
    setCurrentYearPagos(filteredPagos);
  }, [pagos]);

  // Cargar estudiantes y profesores según el rol del usuario
  useEffect(() => {
    const loadUsers = async () => {
      if (user?.rol_id === 1) {
        await fetchStudents();
        await fetchTeachers();
      } else if (user?.rol_id === 2) {
        await fetchStudentsByDirector(user.id); // Cargar estudiantes del director
      }
    };

    if (user) {
      loadUsers();
    }
  }, [fetchStudents, fetchTeachers, user]);

  useEffect(() => {
    setTotalStudents(students.length);
    setTotalTeachers(teachers.length);
    setTotalEvents(eventos.length);
  }, [students, teachers, eventos]);

  // Función para manejar el clic en el calendario
  const handleDayClick = () => {
    navigate("/eventos"); // Redirigir a la página de eventos
  };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      
      <Sidebar />

      <main className="flex-1 p-6">
        <HeaderPage />

        {/* Métricas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Mostrar estudiantes para rol_id 1 y 2 */}
          {(user?.rol_id === 1 || user?.rol_id === 2) && (
            <div className="bg-white p-4 rounded-2xl flex items-center space-x-4">
              <div className="w-12 h-12 bg-main-bg-sidebar rounded-full flex items-center justify-center">
                <FaUserGraduate className="text-white text-2xl" />
              </div>
              <div>
                <h2 className="text-blue-800 text-lg font-semibold">
                  Estudiantes
                </h2>
                <p className="text-2xl font-bold">{totalStudents}</p>
              </div>
            </div>
          )}

          {/* Mostrar profesores solo para rol_id 1 */}
          {user?.rol_id === 1 && (
            <div className="bg-white p-4 rounded-2xl flex items-center space-x-4">
              <div className="w-12 h-12 bg-orange rounded-full flex items-center justify-center">
                <FaUserTie className="text-white text-2xl" />
              </div>
              <div>
                <h2 className="text-orange-700 text-lg font-semibold">
                  Profesores
                </h2>
                <p className="text-2xl font-bold">{totalTeachers}</p>
              </div>
            </div>
          )}

          {/* Mostrar eventos para todos los roles */}
          <div className="bg-white p-4 rounded-2xl flex items-center space-x-4">
            <div className="w-12 h-12 bg-green rounded-full flex items-center justify-center">
              <FaCalendar className="text-white text-2xl" />
            </div>
            <div>
              <h2 className="text-green-800 text-lg font-semibold">Eventos</h2>
              <p className="text-2xl font-bold">{totalEvents}</p>
            </div>
          </div>
        </div>

        {/* Calendario y Finanzas */}
        <div className={`grid ${user?.rol_id === 2 ? "grid-cols-1" : "lg:grid-cols-2"} gap-6 mt-6`}>
          <div className="bg-white p-6 rounded-2xl shadow flex justify-center items-center w-full">
            <DashboardCalendar eventos={eventos} onDayClick={handleDayClick} />
          </div>

          {/* Mostrar finanzas solo para rol_id 1 */}
          {user?.rol_id === 1 && (
            <div className="bg-white p-6 rounded-2xl shadow">
              <h2 className="text-xl  font-semibold mb-4">Finanzas Escolares</h2>
              <DiagramaFinanzas pagos={currentYearPagos} chartType="bar" />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
